import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { finalize, map } from 'rxjs';
import { SpinnerOverlayComponent } from 'src/app/components/spinner-overlay/spinner-overlay.component';
import {
  DoppiaMaterialitaService,
  QuestionarioValidazioneIro,
} from 'src/app/services/doppia-materialita/doppia-materialita.service';
import { TemaService } from 'src/app/services/tema/tema.service';

@Component({
  selector: 'app-validazione-iro-esterna',
  standalone: false,

  templateUrl: './validazione-iro-esterna.component.html',
  styleUrl: './validazione-iro-esterna.component.scss',
})
export class ValidazioneIroEsternaComponent {
  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;

  public logoPath: string = 'assets/images/logo/logo-sostenibile.png';
  public completato: boolean = false;

  public temporaryToken!: string;
  public idMaterialita: string = '';
  public idAzienda: string = '';

  public descrizione: string = '';
  public messaggio: string = '';
  public landingPage: string | undefined;
  public anteprima: boolean = false;

  public strutturaValidazione: QuestionarioValidazioneIro | undefined = undefined;
  public validazioneVuota: boolean = false;
  public loading = true;

  constructor(
    private readonly route: ActivatedRoute,
    private doppiaMaterialitaService: DoppiaMaterialitaService,
    private readonly temaService: TemaService,
  ) {
    this.temaService.temaUpdated.subscribe((tipoInstallazione) => {
      this.logoPath = temaService.logoPath;
    });
  }

  ngAfterViewInit(): void {
    this.parametriDaURL();
  }

  /**
   * Metodo che mi prende il token dal URL
   */
  public parametriDaURL() {
    // Sottoscrivi all'observable paramMap per ottenere i parametri dall'URL
    this.spinnerOver.show();
    this.route.queryParams.subscribe((params) => {
      // Ora puoi accedere ai parametri come segue
      this.temporaryToken = params['temporaryToken'];
      this.idMaterialita = params['id'];
      this.idAzienda = params['idA'];

      if (this.temporaryToken) {
        this._getSurveyByTemporaryToken();
      } else if (this.idMaterialita && this.idAzienda) {
        this._getAnteprimaQuestionarioValidazione();
      } else {
        this.spinnerOver.hide();
      }
    });
  }

  /**
   * Metodo che mi prende i dati della survey dal token
   */
  private _getSurveyByTemporaryToken() {
    this.anteprima = false;

    this.messaggio = '';

    this.doppiaMaterialitaService
      .getQuestionarioValidazioneDaEsterno(this.temporaryToken)
      .subscribe({
        next: (esito) => {
          this.landingPage = esito.landing || '';

          if (esito.questionarioDaCompilare?.questionari?.length) {
            this.strutturaValidazione = esito.questionarioDaCompilare.questionari[0];
          }

          this.validazioneVuota = false;

          this.spinnerOver.hide();

          this.loading = false;
        },
        error: (err) => {
          console.error(err);

          this.messaggio = err?.error?.message;

          if (!this.messaggio) {
            this.messaggio = 'Nessun dato trovato';
          }
          this.validazioneVuota = true;
          this.loading = false;
          this.spinnerOver.hide();
        },
      });
  }

  private _getAnteprimaQuestionarioValidazione() {
    this.anteprima = true;

    this.doppiaMaterialitaService
      .getAnteprimaQuestionarioValidazioneDaCompilare(this.idAzienda, this.idMaterialita)
      .subscribe({
        next: (esito) => {
          this.landingPage = esito.landing || undefined;

          if (esito.questionarioDaCompilare?.questionari?.length) {
            this.strutturaValidazione = esito.questionarioDaCompilare.questionari[0];
          }

          this.validazioneVuota = false;

          this.spinnerOver.hide();

          this.loading = false;
        },
        error: (err) => {
          console.error(err);
          this.spinnerOver.hide();
          this.messaggio = err?.error?.message || 'Nessun dato trovato';
          this.validazioneVuota = true;
        },
      });
  }

  finitaCompilazione(event: { questionario: QuestionarioValidazioneIro; isBozza: boolean }) {
    const qst = event.questionario;

    if (qst) {
      delete qst.id;

      this.spinnerOver.show();

      this.doppiaMaterialitaService
        .salvaQuestionarioValidazioneDaEsterno(this.temporaryToken, qst)
        .pipe(finalize(() => this.spinnerOver.hide()))
        .subscribe({
          next: (risp) => {
            this.completato = true;
          },
          error: (err) => {
            console.error(err);
          },
        });
    }
  }
}
